const LoginIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <mask
        id="mask0_1465_26565"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1465_26565)">
        <path
          d="M7.77083 13.5625C7.61806 13.3819 7.54167 13.1771 7.54167 12.9479C7.54167 12.7188 7.61806 12.5278 7.77083 12.375L9.3125 10.8333H3.33333C3.09722 10.8333 2.89931 10.7535 2.73958 10.5938C2.57986 10.434 2.5 10.2361 2.5 10C2.5 9.76389 2.57986 9.56597 2.73958 9.40625C2.89931 9.24653 3.09722 9.16667 3.33333 9.16667H9.3125L7.77083 7.625C7.60417 7.45833 7.52083 7.26042 7.52083 7.03125C7.52083 6.80208 7.60417 6.60417 7.77083 6.4375C7.92361 6.27083 8.11458 6.1875 8.34375 6.1875C8.57292 6.1875 8.76389 6.26389 8.91667 6.41667L11.9167 9.41667C12 9.5 12.059 9.59028 12.0938 9.6875C12.1285 9.78472 12.1458 9.88889 12.1458 10C12.1458 10.1111 12.1285 10.2153 12.0938 10.3125C12.059 10.4097 12 10.5 11.9167 10.5833L8.91667 13.5833C8.75 13.75 8.55556 13.8264 8.33333 13.8125C8.11111 13.7986 7.92361 13.7153 7.77083 13.5625ZM10.8333 17.5C10.5972 17.5 10.3993 17.4201 10.2396 17.2604C10.0799 17.1007 10 16.9028 10 16.6667C10 16.4306 10.0799 16.2326 10.2396 16.0729C10.3993 15.9132 10.5972 15.8333 10.8333 15.8333H15.8333V4.16667H10.8333C10.5972 4.16667 10.3993 4.08681 10.2396 3.92708C10.0799 3.76736 10 3.56944 10 3.33333C10 3.09722 10.0799 2.89931 10.2396 2.73958C10.3993 2.57986 10.5972 2.5 10.8333 2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H10.8333Z"
          fill="#969696"
        />
      </g>
    </svg>
  );
};

export default LoginIcon;
